import * as swcHelpers from '@swc/helpers';
import { GET_CHECKOUT_STATE } from '../../operations/queries/get-checkout-state.js';

function getCheckoutState(apolloClient, cartId, cartHash) {
    return _getCheckoutState.apply(this, arguments);
}
function _getCheckoutState() {
    _getCheckoutState = swcHelpers.asyncToGenerator(function*(apolloClient, cartId, cartHash) {
        var ref, ref1;
        const { data , error  } = yield apolloClient.query({
            query: GET_CHECKOUT_STATE,
            variables: {
                getCartId: cartId
            },
            fetchPolicy: 'network-only',
            context: {
                forwardHeaders: {
                    'cart-hash': cartHash || null
                }
            }
        });
        if (error) {
            console.error(error);
            throw new Error(error.message);
        }
        return {
            checkoutState: (ref = data.getCart) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.checkoutState
        };
    });
    return _getCheckoutState.apply(this, arguments);
}

export { getCheckoutState };
//# sourceMappingURL=get-checkout-state.js.map
